import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/leistungen",
      name: "leistungen",
      component: () =>
        import("./views/Leistungen.vue")

    },
    {
      path: '/anfahrt',
      name: 'anfahrt',
      component: () =>
        import('./views/Anfahrt.vue')
    },
    {
      path: '/bilder',
      name: 'Bilder',
      component: () =>
        import('./views/Bilder.vue')
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: () =>
      import('./views/Impressum.vue')
    }
  ]
});
